import { render, staticRenderFns } from "./ModalEditTags.vue?vue&type=template&id=e51254fa"
import script from "./ModalEditTags.vue?vue&type=script&lang=js"
export * from "./ModalEditTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports